import { ConfigType, AlertLevels } from 'types'

const config: ConfigType = {
  basePath: 'admin',
  featureToggle: {
    data: {
      exportInvoicePDF: 'off',
      exportInvoiceSpecificationExcel: 'off',
      invoiceRecipientAdmins: 'off',
    }
  },
  api: 'http://csv-d-apps2:8438',
  keycloak: {
    origin: 'https://sso-test.betala.coop.se',
    url: 'https://sso-test.betala.coop.se/auth',
    realm: 'coop-dev',
    clientIds: {
      userNamePass: 'backoffice-web-redirect',
      bankId: 'bankid-redirect',
    },
    queryParams: {
      scope: 'openid',
      'ssl-required': 'all',
      'public-client': true,
      redirect_uri: `${location.origin  }/auth/index.html`,
      ui_locales: 'sv',
      kc_locale: 'sv',
      origin: "inkop-admin",
      login_message: "Logga%20in%20som%20admin%20i%20fakturatj%C3%A4nsten"
    },
    logoutRedirectUri: {
      bankid: `${location.origin}/admin`,
    },
  },
  menu: [
    { link: '/', text: 'title./' },
    { link: '/organisation', text: 'title./organisation' },
    { link: '/orgkonto', text: 'title./orgkonto' },
    { link: '/fakturamottagare', text: 'title./fakturamottagare' },
    { link: '/kopare', text: 'title./kopare' },
    { link: '/kop', text: 'title./kop' },
    { link: '/faktura', text: 'title./faktura' }
  ],
  lang: 'sv',
  appName: 'INKOPS-ADMIN-GUI',
  locations: {
    login: {
      to: '/authenticate',
    },
    loginDestination: {
      to: '/',
    },
    loggedOut: {
      to: '/logga_ut',
    },
    noLogin: {
      to: '/fel',
      state: {
        alert: {
          level: AlertLevels.ERROR,
          message: 'NO_LOGIN',
        },
        destination: '/',
      },
    },
    accessDenied: {
      to: '/fel',
      state: {
        alert: {
          level: AlertLevels.ERROR,
          message: 'ACCESS_DENIED',
        },
        destination: '/',
      },
    },
    pageNotFound: {
      to: '/fel',
      state: {
        alert: {
          level: AlertLevels.ERROR,
          message: 'PAGE_NOT_FOUND',
        },
        destination: '/',
      },
    },
  },
}

export default config
